
import { loginLogic } from '@/views/login/controller';

export default loginLogic;
